import { TransactionConfirmRequest, } from '@/features/Transactions/transactions.types'
import { devtools, persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { create } from '../store'
import { getStorageKey } from '@/shared/helpers/localStorage'

interface TransactionsStore {
  setTransaction(transaction: TransactionConfirmRequest): void;
  transaction: TransactionConfirmRequest;
}

export const useTransactionsStore = create<TransactionsStore>()(
  devtools(
    persist(
      immer((set) => ({
        transaction: null,
        setTransaction: (transaction: TransactionConfirmRequest) => set(() => ({ transaction }), false, 'setTransaction'),
      })),
      {
        name: getStorageKey('godefi:transactionStorage'),
        partialize: (state) => ({ transaction: state.transaction }),
      },
    ),
    {
      name: 'useTransactionsStore',
    },
  ),
)
